import SortIcon from "@Icons/SortIcon";
import styles from "../filterSection.module.scss";
import config from "@Config/index";

export const FILTERS = [
  {
    name: "Housing Type",
    title: "Housing Type",
    key: "housing_type",
    whitelabelTitle: "All Accommodations",
    translationKey: "searchpage.searchlist.filtersubsection.housingtype",
  },
  {
    name: "University",
    title: "University",
    key: "university",
    whitelabelTitle: "University",
    translationKey: "searchpage.searchlist.filtersubsection.university",
  },
  {
    name: "Locality",
    title: "Locality",
    key: "locality",
    whitelabelTitle: "Locality",
    translationKey: "searchpage.searchlist.filtersubsection.locality",
  },
  {
    name: "Budget",
    title: "Budget",
    suffix: "(in weeks)",
    key: "range_available_price",
    whitelabelTitle: "Budget",
    translationKey: "searchpage.searchlist.filtersubsection.budget",
  },
  {
    name: "Move in Month",
    title: "Move in Month",
    key: "move_in_month",
    whitelabelTitle: "Move in Month",
    translationKey: "searchpage.searchlist.filtersubsection.moveinmonth",
  },
  {
    name: "Stay Duration",
    title: "Stay Duration",
    key: "leaseDuration",
    whitelabelTitle: "Stay Duration",
    translationKey: "searchpage.searchlist.filtersubsection.stayduration",
  },
  {
    name: "Room Type",
    title: "Room Type",
    key: "meta_types",
    whitelabelTitle: "Type of Room",
    translationKey: "searchpage.searchlist.filtersubsection.roomtype",
  },
  {
    name: "Guarantor",
    title: "Guarantor",
    key: "guarantor",
    whitelabelTitle: "Guarantor",
    translationKey: "searchpage.searchlist.filtersubsection.guarantor",
  },
  // {
  //   name: 'Sharing',
  //   title: 'Sharing',
  //   key: 'meta_types',
  //   translationKey: "searchpage.searchlist.filtersubsection.sharing",
  // },
  {
    name: "Availability",
    title: "Availability",
    key: "available",
    whitelabelTitle: "Availability",
    translationKey: "searchpage.searchlist.filtersubsection.availability",
  },
  {
    name: "Dual Occupancy",
    title: "Dual Occupancy",
    key: "tags",
    whitelabelTitle: "Dual Occupancy",
    translationKey: "searchpage.searchlist.filtersubsection.dualoccupancy",
  },
  {
    name: "Property Type",
    title: "Property Type",
    key: "meta_unit_types",
    whitelabelTitle: "Property Type",
    translationKey: "searchpage.searchlist.filtersubsection.propertytype",
  },
  {
    name: "Distance from City Centre",
    title: "Distance from City Centre",
    key: "region_radius",
    whitelabelTitle: "Distance from City Centre",
    translationKey: "searchpage.searchlist.filtersubsection.distancefromcitycentre",
  },
  {
    name: "Amenities",
    title: "Amenities",
    key: "amenities",
    whitelabelTitle: "Amenities",
    translationKey: "searchpage.searchlist.filtersubsection.amenities",
  },
  {
    name: "Bills Included",
    title: "Bills Included",
    key: "bills_included",
    whitelabelTitle: "Bills Included",
    translationKey: "searchpage.searchlist.filtersubsection.billsincluded",
  },
  {
    name: "Housing Fest",
    title: "Housing Fest",
    key: "amber_sale_status",
    whitelabelTitle: "Housing Fest",
    translationKey: "searchpage.searchlist.filtersubsection.housingfest",
  },
] as const;

export const SORT_FILTER = {
  name: "Sort",
  title: "Sort",
  key: "sort_key",
  icon: SortIcon,
  whitelabelTitle: "Sort by",
} as const;

export const getInternalFilters = (isMobile = false) => {
  const defaultFilters = [
    {
      name: "Amenities",
      title: "Amenities",
      key: "amenities",
    },
  ];
  const mobileFilters = [{ name: "Internal", title: "Internal" }];
  if (isMobile) {
    return [...defaultFilters, ...mobileFilters];
  }

  return defaultFilters;
};

// Flag to control whether Locality pill shows only when active on desktop (true) or always (false)
export const HIDE_LOCALITY_FROM_TOP_BAR = true;

export const MAIN_FILTERS = FILTERS.slice(0, 7);

export const LOCALITY_FILTER = FILTERS.find((f) => f.name === "Locality");

// Amenities filter for main filter pills
export const AMENITIES_FILTER = FILTERS.find((f) => f.name === "Amenities");

// Bills Included filter for main filter pills
export const BILLS_INCLUDED_FILTER = FILTERS.find((f) => f.name === "Bills Included");

// Housing Fest filter for main filter pills
export const HOUSING_FEST_FILTER = FILTERS.find((f) => f.name === "Housing Fest");

// Extended main filters including Amenities and Bills Included
export const MAIN_FILTERS_WITH_AMENITIES = [
  ...MAIN_FILTERS,
  ...(AMENITIES_FILTER ? [AMENITIES_FILTER] : []),
  ...(BILLS_INCLUDED_FILTER ? [BILLS_INCLUDED_FILTER] : []),
];

export const searchSubsectionFilterKeys = ["range_available_price", "meta_types", "move_in_month"];
export const searchSubsectionFilter2Keys = ["university", "leaseDuration", "region_radius"];
export const SEARCH_SUBSECTION_FILTERS = FILTERS.filter((filter) =>
  searchSubsectionFilterKeys.includes(filter.key),
).sort(
  (a, b) => searchSubsectionFilterKeys.indexOf(a.key) - searchSubsectionFilterKeys.indexOf(b.key),
);
export const SEARCH_SUBSECTION_FILTERS2 = FILTERS.filter((filter) =>
  searchSubsectionFilter2Keys.includes(filter.key),
).sort(
  (a, b) => searchSubsectionFilter2Keys.indexOf(a.key) - searchSubsectionFilter2Keys.indexOf(b.key),
);

export type MainFiltersWithSort = (
  | typeof SORT_FILTER
  | (typeof MAIN_FILTERS_WITH_AMENITIES)[number]
)[];

export const MAIN_FILTERS_WITH_SORT: MainFiltersWithSort = [
  SORT_FILTER,
  ...MAIN_FILTERS_WITH_AMENITIES,
];

export type PropertyFilterValues = (typeof FILTERS)[number]["name"][];

export const PROPERTY_FILTERS_VALUES: PropertyFilterValues = [
  "Stay Duration",
  "Move in Month",
  "Room Type",
  "Dual Occupancy",
];

export const PROPERTY_FILTERS = FILTERS.filter((it) =>
  PROPERTY_FILTERS_VALUES.includes(it.name),
).sort((a, b) => PROPERTY_FILTERS_VALUES.indexOf(a.name) - PROPERTY_FILTERS_VALUES.indexOf(b.name));

export const SORT_OPTIONS = (t: (key: string) => string) => [
  { value: "relevance_sorting_v2,desc", label: t("searchpage.components.sortoptions.recommended") },
  { value: "distance,asc", label: t("searchpage.components.sortoptions.nearest") },
  { value: "available_price,asc", label: t("searchpage.components.sortoptions.pricelowtohigh") },
  { value: "available_price,desc", label: t("searchpage.components.sortoptions.pricehightolow") },
  { value: "created,desc", label: t("searchpage.components.sortoptions.newlyadded") },
];

export const STAY_DURATION_US = [
  { name: "0-4 months", value: "0 months,4 months", key: "0.0-4.0", group: "short" },
  { name: "5-8 months", value: "5 months,8 months", key: "5.0-8.0", group: "mid" },
  { name: "8+ months", value: "9 months,", key: "8.0-*", group: "long" },
  {
    name: "All",
    value: ",",
    key: "0.0-*",
    group: "all",
  },
];

export const getDistanceFromCityCenterOptions = (t: any) => [
  {
    label: (
      <>
        {t("searchpage.components.filters.distancefromcitycenter")}{" "}
        <span className={styles.distanceLabel}>1 {config.IS_CHINA_APP ? t("Km") : t("Mile")}</span>
      </>
    ),
    value: "1609",
  },
  {
    label: (
      <>
        {t("searchpage.components.filters.distancefromcitycenter")}{" "}
        <span className={styles.distanceLabel}>
          {config.IS_CHINA_APP ? "3" : "2"} {config.IS_CHINA_APP ? t("Km") : t("Miles")}
        </span>
      </>
    ),
    value: "3218",
  },
  {
    label: (
      <>
        {t("searchpage.components.filters.distancefromcitycenter")}{" "}
        <span className={styles.distanceLabel}>
          {config.IS_CHINA_APP ? "8" : "5"} {config.IS_CHINA_APP ? t("Km") : t("Miles")}
        </span>
      </>
    ),
    value: "8046", // Distance in meter
  },
  {
    label: t("searchpage.components.filters.distancefromcitycenter.all"),
    value: "",
  },
];

export const DISTANCE_FROM_CITY_CENTER = (t: any) => [
  {
    label: (
      <>
        {t("searchpage.components.filters.distancefromcitycenter")}{" "}
        <span className={styles.distanceLabel}>{config.IS_CHINA_APP ? "1 Km" : "1 Mile"}</span>
      </>
    ),
    value: "1609",
  },
  {
    label: (
      <>
        {t("searchpage.components.filters.distancefromcitycenter")}{" "}
        <span className={styles.distanceLabel}>{config.IS_CHINA_APP ? "3 Km" : "2 Miles"}</span>
      </>
    ),
    value: "3218",
  },
  {
    label: (
      <>
        {t("searchpage.components.filters.distancefromcitycenter")}{" "}
        <span className={styles.distanceLabel}>{config.IS_CHINA_APP ? "8 Km" : "5 Miles"}</span>
      </>
    ),
    value: "8046", // Distance in meter
  },
  {
    label: t("searchpage.components.filters.distancefromcitycenter.all"),
    value: "",
  },
];

export const STAY_DURATION_COMMON = [
  { name: "0 - 4 Weeks", value: "0 weeks,4 weeks", key: "0.0-4.0", group: "short" },
  { name: "5 - 25 Weeks", value: "5 weeks,25 weeks", key: "5.0-25.0", group: "short" },
  { name: "26 - 40 Weeks", value: "26 weeks,40 weeks", key: "26.0-40.0", group: "mid" },
  { name: "41 - 45 Weeks", value: "41 weeks,45 weeks", key: "41.0-45.0", group: "long" },
  { name: "45+ Weeks", value: "46 weeks,", key: "46.0-*", group: "long" },
  { name: "All", value: ",", key: "0.0-*", group: "all" },
];

export const ACCOMMODATION_TYPES = (t: (key: string) => string) => ({
  name: t("searchpage.components.accommodationtypes.label"),
  type: "meta_unit_types",
  list: [
    {
      value: "independent_house",
      name: t("searchpage.components.accommodationtypes.independenthouse"),
      subText: t("searchpage.components.accommodationtypes.independenthousesubtext"),
    },
    {
      value: "student_accommodation",
      name: t("searchpage.components.accommodationtypes.studentaccommodation"),
      subText: t("searchpage.components.accommodationtypes.studentaccommodationsubtext"),
    },
  ],
});

export const SHARING_OPTIONS_BATHROOM = {
  name: "Bathroom",
  whitelabelName: "Bathroom",
  type: "meta_types",
  mobileGrid: 6,
  list: [
    { value: "private_bathroom", name: "Private Bathroom" },
    { value: "shared_bathroom", name: "Shared Bathroom" },
  ],
};

export const SHARING_OPTIONS_KITCHEN = {
  name: "Kitchen",
  whitelabelName: "Kitchen",
  type: "meta_types",
  mobileGrid: 6,
  list: [
    { value: "private_kitchen", name: "Private Kitchen" },
    { value: "shared_kitchen", name: "Shared Kitchen" },
  ],
};

export const GUARANTOR_OPTIONS_ON_SEARCH_PAGE = (t: (key: string) => string) => [
  {
    name: t("searchpage.components.guarantoroptions.localinternational"),
    value: "international",
    subText: t("searchpage.components.guarantoroptions.localinternationalsubtext"),
    subTextMobile: t("searchpage.components.guarantoroptions.localinternationalsubtextmobile"),
  },
  {
    name: t("searchpage.components.guarantoroptions.local"),
    value: "local",
    subText: t("searchpage.components.guarantoroptions.localsubtext"),
    subTextMobile: t("searchpage.components.guarantoroptions.localsubtextmobile"),
  },
  {
    name: t("searchpage.components.guarantoroptions.noguarantor"),
    value: "false",
    subText: t(""),
    subTextMobile: t(""),
  },
];

export const GUARANTOR_OPTIONS = [
  {
    name: "Only Local Guarantor allowed",
    value: "local",
    subText:
      "Properties that allow only local residents of your destination country to become your rent guarantor",
    subTextMobile: "Properties that allow only local residents of your destination country",
  },
  {
    name: "International and Local Guarantor allowed",
    value: "international",
    subText: "Properties that allow anyone around the globe to become your rent guarantor",
    subTextMobile: "Properties that allow anyone around the globe",
  },
  {
    name: "No Guarantor required",
    value: "false",
    subText: "Properties that don’t require a rent guarantor",
    subTextMobile: "Properties that don’t require a guarantor",
  },
];

export type RoomTypeCombined = {
  name: string;
  whitelabelName: string;
  type: string;
  mobileGrid: number;
  addViewMore?: boolean;
  list: {
    value: string;
    name: string;
    subText?: string;
  }[];
};
// Reusable segments for specific room types
const SPECIFIC_ROOM_PRIVATE_TYPES = [
  {
    value: "ensuite",
    name: "searchpage.specificroomtypes.ensuitetitle",
    subText: "searchpage.components.specificroomtypes.ensuite.subtext",
    type: "specific_room_type",
  },
  {
    value: "non_ensuite",
    name: "searchpage.components.specificroomtypes.nonensuite.title",
    subText: "searchpage.components.specificroomtypes.nonensuite.subtext",
    type: "specific_room_type",
  },
  {
    value: "studio",
    name: "Studio",
    subText:
      "All-in-one space with a bedroom, private bathroom, living area, and kitchenette - Ideal for complete independence",
    type: "specific_room_type",
  },
];

const SPECIFIC_ROOM_APARTMENT_TYPES = [
  {
    value: "1b",
    name: "1B",
    subText: "An apartment with one bedroom, living room, kitchen, and bathroom",
    type: "specific_room_type",
  },
  {
    value: "2b",
    name: "2B",
    subText: "An apartment with two bedrooms, a living room, kitchen, and bathroom",
    type: "specific_room_type",
  },
  {
    value: "3b",
    name: "3B",
    subText: "An apartment with three bedrooms, a living room, kitchen, and bathroom",
    type: "specific_room_type",
  },
  {
    value: "4b",
    name: "4B",
    subText: "An apartment with four bedrooms, a living room, kitchen, and bathroom",
    type: "specific_room_type",
  },
  {
    value: "5b",
    name: "5B",
    subText: "An apartment with five bedrooms, a living room, kitchen, and bathroom",
    type: "specific_room_type",
  },
];

export const ROOM_TYPE_SPECIFIC = {
  name: "Room Type",
  whitelabelName: "Type of Room",
  type: "meta_types",
  mobileGrid: 12,
  addViewMore: true,
  list: [...SPECIFIC_ROOM_PRIVATE_TYPES, ...SPECIFIC_ROOM_APARTMENT_TYPES],
};

export const ROOM_TYPE_SPECIFIC_US = {
  name: "Room Type",
  whitelabelName: "Type of Room",
  type: "meta_types",
  mobileGrid: 12,
  addViewMore: true,
  list: [...SPECIFIC_ROOM_APARTMENT_TYPES, ...SPECIFIC_ROOM_PRIVATE_TYPES],
};

export const ROOM_TYPE_FILTER = {
  name: "Accommodation",
  whitelabelName: "Accommodation",
  type: "meta_types",
  mobileGrid: 12,
  list: [
    // {
    //   value: 'entire_place',
    //   name: 'Entire Place',
    //   subText: 'Relax in the privacy of a fully self-contained property.',
    // },
    {
      value: "private_room",
      name: "Private Room",
      subText: "No need to share in a private room, your sleep/study space is your own.",
      type: "room_type",
    },
    {
      value: "shared_room",
      name: "Shared Room",
      subText: "Enjoy the communal feeling of a shared room.",
      type: "room_type",
    },
  ],
};

export const ROOM_TYPE_COMBINED: RoomTypeCombined[] = [
  ROOM_TYPE_SPECIFIC,
  ROOM_TYPE_FILTER,
  SHARING_OPTIONS_KITCHEN,
  SHARING_OPTIONS_BATHROOM,
];

export const ROOM_TYPE_COMBINED_US: RoomTypeCombined[] = [
  ROOM_TYPE_SPECIFIC_US,
  ROOM_TYPE_FILTER,
  SHARING_OPTIONS_BATHROOM,
  SHARING_OPTIONS_KITCHEN,
];

export const getRoomTypeCombined = (isUS: boolean): RoomTypeCombined[] =>
  isUS ? ROOM_TYPE_COMBINED_US : ROOM_TYPE_COMBINED;
